<template>
<v-form v-model="valid">
    <v-row>
        <v-col cols="12" md="8" offset-md="2">
            <v-alert outlined type="info" text class="pa-2">
                <template v-slot:prepend>
                    <v-icon size="24" color="blue" class="mr-2">info</v-icon>
                </template>
                <span>
                    In acest pas, va rugam sa introduceti informatiile reale, referitoare la tipul unitatii dumneavoastra.
                    Pentru a trece in pasul urmator, completati toate campurile si apasati butonul "Urmatorul pas"
                </span>
            </v-alert>

            <v-select label="Tipul unitatii" v-model="hotel.unit_type" :items="unit_types" required :menu-props="{transition:'scale-transition', 'offset-y': ''}">
                <template v-slot:selection="data">
                    <span class="text-capitalize">{{$t('hotel.detail.unit_types.' + data.item)}}</span>
                </template>
                <template v-slot:item="data">
                    <span class="text-capitalize">{{$t('hotel.detail.unit_types.' + data.item)}}</span>
                </template>
            </v-select>
            <v-text-field label="Numele unitatii" v-model="hotel.name" :rules="rules.name" required />
            <v-row>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field label="Email" v-model="hotel.email" :rules="rules.email" required />
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                    <v-text-field label="Nr de telefon" v-model="hotel.static.defaults.phone" :rules="rules.phone" required />
                </v-col>
                <v-col cols="12" class="d-none">
                    <suglify v-if="hotel.name" :slugify="hotel.name" :slug.sync="hotel.slug" :extras="{'*' : ''}">
                        <v-text-field v-model="hotel.slug" label="Slug" />
                    </suglify>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12">
                    <div :class="{'d-flex align-start justify-space-between':true,'flex-wrap pb-2':$vuetify.breakpoint.smAndDown}">
                        <v-input prepend-icon="place" class="gmap-autocomplete">
                            <gmap-autocomplete ref="gmap" :value="google_address" :componentRestrictions="autocompleteOptions" @place_changed="setPlace($event),show_map=true" class="form-control" :placeholder="$t('hotel.geolocation.search_placeholder')"
                                style="width: 100%;"></gmap-autocomplete>
                        </v-input>
                        <v-btn :class="{'mx-1':!$vuetify.breakpoint.smAndDown}" :block="$vuetify.breakpoint.smAndDown" color="primary" @click="show_map= true">
                            Adauga manual
                        </v-btn>
                    </div>
                    <GmapMap v-if="show_map" :center="center_position" :zoom="15" map-type-id="terrain" style="width: 100%; height: 300px">
                        <GmapMarker v-model="center_position" :position="center_position" :clickable="true" :draggable="true" @dragend="setPlace2($event)" />
                    </GmapMap>
                </v-col>
            </v-row>
            <v-row v-if="show_map">
                <v-col class="py-0" cols="12" md="6">
                    <v-text-field label="Judet" v-model="hotel.static.geo.region" :rules="rules.address_region" required />
                </v-col>
                <v-col class="py-0" cols="12" md="6">
                    <v-text-field label="Localitate" v-model="hotel.static.geo.city" :rules="rules.address_city" required />
                </v-col>
                <v-col class="py-0" cols="8" md="4">
                    <v-text-field label="Strada" v-model="hotel.static.geo.address" />
                </v-col>
                <v-col class="py-0" cols="4" md="2">
                    <v-text-field label="Numar" v-model="hotel.address.number" />
                </v-col>
            </v-row>
        </v-col>
        <v-col cols="12">
            <div class="px-2 d-flex justify-end">
                <div class="">
                    <v-tooltip bottom :disabled="valid||show_map">
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn color="primary" :small="$vuetify.breakpoint.smAndDown" :disabled="!valid||!show_map" @click="nextStep()">
                                    <span v-if="$vuetify.breakpoint.smAndUp">Urmatorul pas</span>
                                    <span v-else>Inainte</span>
                                    <v-icon size="16" color="white">arrow_forward_ios</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <span>Toate campurile sunt obligatorii</span>
                    </v-tooltip>
                </div>
            </div>
        </v-col>
    </v-row>
</v-form>
</template>

<script>
import defaults from "../../../components/utils/PropDefaults.js";
import * as VueGoogleMaps from "vue2-google-maps";
import Axios from "axios";

const axios = Axios.create();

export default {
    name: 'HotelRegistration',
    props: {
        hotel: {
            type: Object,
        },
    },
    data() {
        return {
            valid: null,
            billing_address: false,
            show_map: false,
            google_address: null,
            center_position: {
                lat: Number(defaults.hotel_item.static.geo.lat),
                lng: Number(defaults.hotel_item.static.geo.lon)
            },
            unit_types: ["hotel", "boarding-house", "apartament", "hostel", "cabin", "villa", "motel"],
            countries: [
                {
                    "code": "RO",
                    "name": "Romania"
                },
            ],

            autocompleteOptions: {
                country: ['ro'],
            },

        }
    },

    computed: {
        rules() {
            return {
                name: [v => !!v || "Numele hotelului este obligatoriu"],
                email: [
                    v => !!v || "E-mail este obligatoriu",
                    v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail trebuie sa fie valid"
                ],
                phone: [
                    v => !!v || "Nr de telefon necesar",
                    v => /^.{10,}$/.test(v) || "Nr trebuie sa fie valid"
                ],
                address_country: [v => !!v || this.$t('hotel.geolocation.form_rules.country')],
                address_city: [v => !!v || this.$t('hotel.geolocation.form_rules.city')],
                address_region: [v => !!v || this.$t('hotel.geolocation.form_rules.state')],
                address_street: [v => !!v || this.$t('hotel.geolocation.form_rules.street')],
                address_number: [v => !!v || this.$t('hotel.geolocation.form_rules.number')],
                address_postal_code: [v => !!v || this.$t('hotel.geolocation.form_rules.postcode')],
            }
        }
    },

    created() {},

    methods: {

        setPlace(event_value) {
            this.address = true;
            this.center_position = {
                lat: event_value.latLng.lat(),
                lng: event_value.latLng.lng()
            };
            this.hotel.static.geo.lat = event_value.latLng.lat();
            this.hotel.static.geo.lon = event_value.latLng.lng();

            event_value.address_components.forEach(
                function (place) {
                    this.setAddressInfo(place);
                }.bind(this)
            );
        },

        setPlace2(event_value) {
            this.center_position = {
                lat: event_value.latLng.lat(),
                lng: event_value.latLng.lng()
            };
            this.hotel.static.geo.lat = event_value.latLng.lat();
            this.hotel.static.geo.lon = event_value.latLng.lng();

            axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + event_value.latLng.lat() + "," + event_value.latLng.lng() + "&key=AIzaSyCu1N9tNE8mEh_u4yI3SCOn3M_gV3CgL5E")
                .then(response => {
                    response.data.results[0].address_components.forEach(
                        function (place) {
                            this.setAddressInfo(place);
                        }.bind(this)
                    );
                })
                .catch(e => {
                    this.error(this.$t('hotel.geolocation.message_error_google'));
                    // this.errors.push(e)
                });
        },

        setAddressInfo(place) {
            place.types.forEach(function (item) {
                switch (item) {
                case "street_number":
                    this.hotel.address.number = place.long_name;
                    break;
                case "route":
                    this.hotel.static.geo.address = place.long_name;
                    break;
                case "locality":
                    this.hotel.static.geo.city = place.long_name;
                    break;
                    // case 'administrative_area_level_2':
                    // address.city = place.long_name;
                case "administrative_area_level_1":
                    this.hotel.static.geo.region = place.long_name;
                    break;
                case "country":
                    this.hotel.country_code = place.short_name;
                    break;
                case "postal_code":
                    this.hotel.static.geo.postcode = place.long_name;
                    break;
                }
            }.bind(this));
        },

        nextStep() {
            this.$emit('next');
        },

    },
}
</script>
